import http from "@utils/request";
/**
 * 获取设备列表
 * @returns 
 */
 export const getSiteConfigList=()=>http({
    method: "POST",
    url: "/phemsjava/getSiteConfigList",
})

/**
 * 更新设备数据
 * @returns 
 */
 export const updateSiteConfig=(site)=>http({
    method: "POST",
    url: "/phemsjava/updateSiteConfig",
    data:site,
    contentType:"json"
})